import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const situations = ['Se frustra y entra en crisis porque no puede pedir lo que necesita.', 'Las mañanas, las comidas y las noches son batallas constantes.', 'Vos no sabés exactamente cómo ayudarlo en el momento de la escalada.', 'La escuela no entiende cómo se comunica y eso genera más conflicto.', 'Cada salida afuera es una incógnita que da miedo.'];
export function ProblemSection() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-215">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-216">
        <div className="text-center mb-8" data-id="element-217">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-teal-900" data-id="element-218">
            ¿Hasta cuándo la falta de comunicación va a seguir siendo una crisis
            diaria en tu casa?
          </h2>
          <p className="text-lg text-stone-600 leading-relaxed" data-id="element-219">
            Tu hijo sabe lo que siente y lo que necesita, pero no puede
            decírtelo. Esa brecha es la causa real de cada crisis.
          </p>
          <p className="text-lg font-bold text-coral-600 mt-4" data-id="element-220">
            No es conducta. No es manipulación. No es capricho.
          </p>
        </div>

        <div className="bg-cream rounded-3xl p-8 border border-stone-200 mb-8" data-id="element-221">
          <div className="space-y-4" data-id="element-222">
            {situations.map((text, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start bg-white p-4 rounded-xl shadow-sm border border-stone-100" data-id="element-223">
                <XCircle className="w-5 h-5 text-coral-500 mr-4 flex-shrink-0 mt-1" data-id="element-224" />
                <p className="text-stone-700 font-medium" data-id="element-225">{text}</p>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-226">
          <p className="text-xl font-bold text-teal-900 italic" data-id="element-227">
            ¿Y si las próximas semanas pudieran ser el comienzo de su primera
            comunicación real?
          </p>
        </div>
      </div>
    </section>;
}